import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';

export const SelectorBanner = styled(Box).attrs({
  width: '100%',
  borderRadius: '5px',
  align: 'center',
  justify: 'space-between',

  bg: 'warning',
  mt: '8px',
  mb: '24px',
  py: '10px',
})`
  max-width: 480px;
  min-width: 0;
  height: calc(100% - 8px);
  cursor: pointer;
  border: solid 1px;

  ${({ isClicked, theme }) =>
    isClicked
      ? `background-color: ${theme.colors.transparent};
      border-color: ${theme.colors.lightDanger}
      `
      : `background-color: ${theme.colors.primaryBase};
      border-color: ${theme.colors.transparent}

      `};

  &:hover {
    filter: constrast(1.5);
    filter: brightness(1.5);
  }
`;
export const TextIconWrapper = styled(Box).attrs({
  align: 'center',
  justify: 'center',
  ml: '20px',
})`
  flex: 1;
  min-width: 0;
  cursor: pointer;
`;
export const BannerText = styled(Text).attrs({
  ml: '6px',
  size: 'normal',
})`
  ${({ isClicked, theme }) =>
    isClicked
      ? `color: ${theme.colors.lightDanger}
    `
      : `color: ${theme.colors.background}`};
  min-width: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: auto;
  max-width: 300px;
`;
export const IconWrapper = styled(Box).attrs({})`
  ${({ isClicked, theme }) =>
    isClicked
      ? `color: ${theme.colors.lightDanger}
    `
      : `color: ${theme.colors.background}`};
`;
